module.exports = __webpack_public_path__ + "static/credentials-a8758d26ccae37abac1c2067ea9b7e79.png";